<!--
  name : 김혜진
  desc : 계약요청
  date : 2021-08-04
-->
<template>
  <v-row no-gutters>

    <!--내용-->
    <v-col cols="12" class="write_conYscroll">
      <v-row no-gutters>
        <v-col cols="12" class="docuD_pop_tcp_box">
            <ul class="pattern_ulTxtBox">
              <li>
                <span class="txt_icon">요청</span>
                <span class="txt_txt01" v-for="(officeContractNameList, i) in officeContractNameList" :key="i">
                  {{officeContractNameList}}
                </span>
              </li>
            </ul>
          </v-col>
          <v-col cols="12" class="docuD_pop_tcp_box">
            <ul class="pattern_ulTxtBox">
              <li>
                <span class="txt_icon">블록체인</span>
                <span class="txt_txt02">{{this.$store.state.user.orgaddr}}</span>
              </li>
            </ul>
          </v-col>
          <v-col cols="12" class="mt-2 row_mb-20">              
            <v-text-field class="inputH48_01 W100"
              label="코멘트"
              placeholder="수신자 메일에 코멘트를 남겨주세요"
              maxlength="200"
              outlined
              dense
							v-model="emailMessage"
            >
            </v-text-field>
            <v-text-field class="inputH48_01 conBstar"
              label="블록체인 비밀번호"
              placeholder="블록체인 비밀번호 입력"
              ref="chainPassword"
              outlined
              dense
							v-model="chainPassword"
							:type="'password'"
            >
            </v-text-field>
            <span class="txtst_info_red">- 블록체인 인증이 완료되어야 계약서 전송이 완료됩니다.</span>
          </v-col>
      </v-row>
    </v-col>
    <!--/내용-->

  <s-confirm ref="confirm"></s-confirm>
  <s-loading ref="loading"></s-loading>
  </v-row>
</template>
<script>
import { officeCtrRequest } from '@/api/setting/officeContract'

export default {
  name: 'step03',
  components: {
  },
  filters: {
  },
  props:{
  },
  data () {
    return {
      officeContractInfos: [],
      officeContractNameList: [],
			emailMessage: '',

			ctrFrmStep3A: {
        isCertReqBlckChain: false,
        ctrBlckChainPw: ''
			},
      // 블록체인 인증 창 파라메터 값
      chainPassword: '',
      // 사내계약 요청 시 파라미터
      reqCtrInfo: {
        chainPass: '',
        groupId: null,
        subInfos: null
      },
      // 블록체인 인증 창 파라메터 값
      authForm: {
        sender: '',
        chainAddress: '',
        chainPassword: ''
      },
    }
  },
  created () {
  },
  mounted () {
    this.officeContractInfos = this.$store.state.app.officeContractInfos[0].contractInfos
    this.groupId = this.$store.state.app.officeContractInfos[0].groupId
    this.authForm.sender = ''
    this.authForm.chainAddress = this.$store.state.user.orgaddr
    for (var i in this.officeContractInfos) {
      if (this.officeContractInfos[i].status === 'success') {
        this.officeContractNameList.push(this.officeContractInfos[i].receiver)
      }
    }
  },
  methods: {
    // 블록체인 비밀번호 입력 후 확인 눌렀을 때 호출되는 함수
    submitAuthChain () {
      if (this.$refs.chainPassword.validate()) {
        this.$refs.loading.start('사내계약 요청중입니다')

          this.reqCtrInfo.chainPass = this.chainPassword
          this.reqCtrInfo.groupId = this.groupId
          this.reqCtrInfo.subInfos = encodeURIComponent(JSON.stringify(this.$store.state.app.officeContractMetaStr))

          officeCtrRequest(this.reqCtrInfo).then(response => {
            this.$refs.loading.end()
            if (response.rdata.rcode === 20000) {
              this.chainAuthDialogVisible = false
              this.$refs.confirm.open('alert','사내계약', '사내계약 요청이 완료 되었습니다.').then(() => {
                this.$router.push('officeContractList')
              })
            } else {
              this.$refs.confirm.open('alert','사내계약', '계약서 변환 요청에 실패했습니다. ( error : ' + response.rdata.rmessage + ' )')
            }
          }).catch(e => {
            console.error(e)
          })

      }
    },
  }
}
</script>
<style>

</style>